<script setup lang="ts">
import { AccordionContent } from 'reka-ui'
import type { AccordionContentProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { cn } from '@/utils/shadcn/lib/utils.ts'
import { reactiveOmit } from '@vueuse/core'

defineOptions({
    compatConfig: {
        MODE: 3,
    },
})

const props = defineProps<AccordionContentProps & { class?: HTMLAttributes['class'] }>()

const delegatedProps = reactiveOmit(props, 'class')
</script>

<template>
    <AccordionContent
        data-slot="accordion-content"
        v-bind="delegatedProps"
        class="data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden text-sm"
    >
        <div :class="cn('pt-0 pb-4', props.class)">
            <slot></slot>
        </div>
    </AccordionContent>
</template>
